import { useTranslation } from 'next-i18next'
import React from 'react'

import { Footer } from '@web-apps/feature-creator-page'
import { clientConfig, Localisation } from '@web-apps/utils-shared'

import { SEOMetaHead } from './SEOMetaHead'

import {
  StyledContainer,
  StyledContent,
  StyledContentWrapper,
} from './PageWrapper.styles'
import { PageWrapperProps } from './PageWrapper.types'

export const PageWrapper: React.FC<PageWrapperProps> = ({
  children,
  language = Localisation.DEFAULT_LANGUAGE,
  seo,
  hasFooter,
  fullWidth,
  ...divProps
}) => {
  const { t } = useTranslation(['common'])

  return (
    <StyledContainer>
      <SEOMetaHead {...seo} />

      <StyledContentWrapper id="scrollable-wrapper">
        <StyledContent
          id="page-content-wrapper"
          $fullWidth={fullWidth}
          $hasFooter={hasFooter}
          {...divProps}
        >
          {children}
        </StyledContent>
        {hasFooter && (
          <Footer
            title={t('common:footer_title')}
            url={`${clientConfig?.CREATOR_APP_V2_BASE_URL}/signup`}
          />
        )}
      </StyledContentWrapper>
    </StyledContainer>
  )
}
